import axios from "../api"
import { getToken } from "../util/util"

export const analyzeJobDescription = ({ title, description }) =>
  axios.post("/jobs/analyze", { title, description }, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      "Cache-Control": "no-cache",
    },
  })

export const analyzeJobDescriptionStreaming = async ({ title, description }) =>
  axios.post("/jobs/analyze/stream", { title, description }, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      "Cache-Control": "no-cache",
    },
  }).then((res) => res.data)

/**
 * @param {*} body
 * @returns {{title: string; description: string}}
 */
export const parseJobRequirementsFile = (body) =>
  axios
    .post("/jobs/requirements/file", body, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        "Cache-Control": "no-cache",
      },
    })
    .then((res) => res.data)

export const getJobDetail = (jobId) =>
  axios.get("/jobs/detail", {
    params: { jobId },
    headers: {
      Authorization: `Bearer ${getToken()}`,
      "Cache-Control": "no-cache",
    },
  }).then((res) => res.data)

export const selectCandidates = (body) =>
  axios.post("/jobs/select-candidates", body, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      "Cache-Control": "no-cache",
    }
  })

export const getMatchByJobId = (jobId) =>
  axios.get(`/jobs/${jobId}/match`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
      "Cache-Control": "no-cache",
    },
  }).then((res) => res.data)

export const postMatchRequirements = (body) =>
  axios.post("/jobs/requirements_match", body, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
      "Cache-Control": "no-cache",
    },
  }).then((res) => res.data)

export const getJobs = () =>
  axios
    .get("/jobs/list", {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        "Cache-Control": "no-cache",
      },
    })
    .then((res) => res.data)

// Scoped PATCH helpers — send only the dimension that changed. The API's
// PUT /jobs/:id replaces each dimension it receives; sending the whole job
// on every edit rewrites skills/info together, wastes bandwidth, and forces
// stale fields like `experience_preference` through a filter that silently
// drops them.

export const updateJobInformation = (jobId, information) =>
  axios.put(`/jobs/${jobId}`, { information }, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      "Cache-Control": "no-cache",
    },
  }).then((res) => res.data)

export const updateJobSkills = (jobId, { hard_skills, soft_skills }) => {
  const payload = {}
  if (hard_skills !== undefined) payload.hard_skills = hard_skills
  if (soft_skills !== undefined) payload.soft_skills = soft_skills

  return axios.put(`/jobs/${jobId}`, payload, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      "Cache-Control": "no-cache",
    },
  }).then((res) => res.data)
}

export const deleteJobs = (jobIds = []) =>
  axios.delete("/jobs", {
    data: { ids: jobIds },
    headers: {
      Authorization: `Bearer ${getToken()}`,
      "Cache-Control": "no-cache",
    },
  }).then((res) => res.data)

